import { Fragment, FunctionComponent } from 'react';
import Pagination from '../../shared/Pagination';
import { Table, TableHead, TableHeader, TableRow } from '../../shared/Table';
import { usePagination } from '../../shared/usePagination';
import { LocationResponse } from '../models/GetApartmentsResponse';

type Props = {
    locations: LocationResponse[];
    setLocation: (location: LocationResponse | undefined) => void;
};

const LocationList: FunctionComponent<Props> = ({ locations, setLocation }) => {
    const { currentPage, setCurrentPage, currentItems, totalPages, itemsPerPage } = usePagination(locations ?? []);

    return (
        <div className="mb-5">
            <h2>Adresser</h2>
            {locations ? (
                <Fragment>
                    <Table withPagination={totalPages > 1}>
                        <TableHead>
                            <tr>
                                <TableHeader>Adress</TableHeader>
                                <TableHeader className="text-end">Antal lägenheter</TableHeader>
                            </tr>
                        </TableHead>
                        <tbody>
                            {currentItems.map((location) => (
                                <TableRow key={location.locationId} onClick={() => setLocation(location)}>
                                    <td>{location.name}</td>
                                    <td className="text-end">{location.count}</td>
                                </TableRow>
                            ))}
                        </tbody>
                    </Table>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalItems={locations.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={setCurrentPage}
                        ariaLabel="Adresslistans sidnavigering"
                    />
                </Fragment>
            ) : (
                <p>Inga adresser hittades.</p>
            )}
        </div>
    );
};

export default LocationList;
